import styled from "styled-components";

import { TextField as MuiTextField } from "@mui/material";
import { InputLabel, Select } from "@mui/material";

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
  color: #191c1a;
`;

export const Typography = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #0f0f1e99;
  opacity: 0.6;
  margin: 0;
`;

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  color: #a2a2a2;

  & .Mui-focused {
    color: blue;
  }
`;

export const StyledTextField = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: rgb(121, 121, 121);
    }

    &.Mui-focused fieldset {
      border-width: 1px;
    }
  }

  & .MuiInputLabel-root {
    color: #a2a2a2;
  }
`;
